/**
 * Photo & Craft — Optium Glazing Upgrade controller (checkbox UI)  v2
 *
 * Checked = Optium upgrade, unchecked = standard UV-conservation clear (included).
 *
 * v2 adds the CART-ADD logic that was missing: when the customer adds to cart
 * with Optium checked, it adds BOTH the base framed item and the matching
 * size's Optium upgrade variant in one /cart/add.js call, linked by a hidden
 * _glaze_group property (mirrors the original working implementation).
 */
(function () {
  'use strict';

  var OPTIUM_HANDLE = 'optium-museum-acrylic-upgrade';
  var SIZE_WORDS = ['Small', 'Medium', 'Large', 'Gallery', 'Collector', 'Exhibition'];

  var optiumVariants = null;   // [{ size, id, price }]
  var lastSizeWord = null;

  function log() { if (window.PC_DEBUG) console.log.apply(console, ['[optium]'].concat([].slice.call(arguments))); }
  function fmt(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  function sizeWordIn(str) {
    if (!str) return null;
    for (var i = 0; i < SIZE_WORDS.length; i++) if (str.indexOf(SIZE_WORDS[i]) !== -1) return SIZE_WORDS[i];
    return null;
  }

  function fetchOptium() {
    return fetch('/products/' + OPTIUM_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) { log('fetch failed', r.status); return null; } return r.json(); })
      .then(function (p) {
        if (!p) return null;
        optiumVariants = p.variants.map(function (v) {
          var word = sizeWordIn(v.option1) || sizeWordIn(v.title) || sizeWordIn(v.public_title) ||
                     (v.options && sizeWordIn(v.options.join(' ')));
          return { size: word, id: v.id, price: v.price };
        });
        log('loaded variants', optiumVariants);
        return optiumVariants;
      })
      .catch(function (e) { log('fetch error', e); return null; });
  }

  function currentSizeWord() {
    var el = document.querySelector('.pc-size-row.active .pc-size-row-name');
    return el ? el.textContent.trim() : null;
  }
  function variantForWord(word) {
    if (!optiumVariants || !word) return null;
    for (var i = 0; i < optiumVariants.length; i++) if (optiumVariants[i].size === word) return optiumVariants[i];
    return null;
  }

  function init() {
    var wrap = document.querySelector('[data-glazing]');
    var box  = document.querySelector('[data-glazing-toggle]');
    if (!wrap || !box) { log('no glazing markup'); return; }

    var hidden  = wrap.querySelector('[data-glaze-value]');
    var priceEl = wrap.querySelector('[data-optium-price]');

    function isOptium() { return box.classList.contains('active'); }

    function refreshPrice() {
      var v = variantForWord(currentSizeWord());
      if (priceEl) priceEl.textContent = v ? ('+ ' + fmt(v.price)) : '—';
    }

    function setState(on) {
      box.classList.toggle('active', on);
      box.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (hidden) { hidden.value = on ? 'optium' : 'standard'; hidden.dispatchEvent(new Event('change', { bubbles: true })); }
      log('state', on ? 'optium' : 'standard');
    }

    box.addEventListener('click', function () { setState(!isOptium()); });

    // Re-price on size change (light poll — robust against selector re-renders).
    setInterval(function () {
      var w = currentSizeWord();
      if (w !== lastSizeWord) { lastSizeWord = w; refreshPrice(); }
    }, 250);

    // ── CART ADD: intercept the product form submit when Optium is selected ──
    var form = box.closest('form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!isOptium()) return;                 // standard glazing -> normal add
        var upgrade = variantForWord(currentSizeWord());
        if (!upgrade) return;                    // no upgrade for this size -> normal add

        e.preventDefault();
        e.stopImmediatePropagation();

        var baseIdInput = form.querySelector('[name="id"]');
        var baseId = baseIdInput ? baseIdInput.value : null;
        if (!baseId) { form.submit(); return; }

        // Identify the exact piece so the studio knows which artwork/size/frame
        // gets Optium — critical when a cart has multiple pieces at the same size.
        var group = 'opt-' + Date.now() + '-' + Math.floor(Math.random() * 1e4);
        var title = ((document.querySelector('.product__title h1, .product__title h2') || {}).textContent || '').trim();
        var sizeWord = currentSizeWord() || '';
        var frameRow = document.querySelector('.pc-frame-swatch.active');
        var frameName = frameRow ? (frameRow.getAttribute('data-frame') || '') : '';
        var mountBtn = document.querySelector('.pc-style-toggle button.active');
        var mountName = mountBtn ? mountBtn.textContent.trim() : '';
        // Pull the base variant SKU if the selector exposes it via the variant JSON.
        var baseSku = '';
        try {
          var pj = document.querySelector('[data-pc-product-json]');
          if (pj) {
            var prod = JSON.parse(pj.textContent);
            for (var vi = 0; vi < prod.variants.length; vi++) {
              if (String(prod.variants[vi].id) === String(baseId)) { baseSku = prod.variants[vi].sku || ''; break; }
            }
          }
        } catch (err) { /* sku is best-effort */ }

        // A human-readable descriptor that prints on the order line.
        var pieceDesc = title + (sizeWord ? ' — ' + sizeWord : '') +
                        (mountName ? ' / ' + mountName : '') +
                        (frameName ? ' / ' + frameName : '');

        var btn = form.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: baseId, quantity: 1,
                properties: {
                  'Glazing': 'Optium\u00ae Museum Acrylic',
                  '_glaze_group': group
                } },
              { id: upgrade.id, quantity: 1,
                properties: {
                  '_glaze_group': group,
                  'Upgrade for': pieceDesc,
                  '_piece_title': title,
                  '_piece_size': sizeWord,
                  '_piece_frame': frameName,
                  '_piece_mount': mountName,
                  '_piece_sku': baseSku,
                  '_base_variant_id': String(baseId)
                } }
            ]
          })
        })
        .then(function (r) { return r.json(); })
        .then(function () { window.location = '/cart'; })
        .catch(function (err) {
          log('cart add failed', err);
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
          form.submit(); // fallback: at least add the base item normally
        });
      }, true); // capture phase — run before Dawn's own submit handler
    } else {
      log('no cart form found — add-to-cart interception inactive');
    }

    fetchOptium().then(refreshPrice);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();